import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import api from "../../../axiosConfig";
import { popup } from "../../common/popup";

export default function KaizenTab() {
  const [allMaterials, setAllMaterials] = useState([]);
  const [machines, setMachines] = useState([]);
  const [search, setSearch] = useState("");
  const [form, setForm] = useState({
    mesin: "",
    pic: "",
    tanggal: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, []);
  const loadData = async () => {
    try {
      const itemRes = await axios.get(
        "/api/maintenance/kaizen/stock-items",
      );

      const items = itemRes.data.map((item) => ({
        id: item.id,
        type: "ITEM",
        nama: item.part_name,
        spesifikasi: item.spesifikasi,
        stock: item.stock,
        qty: "",
        note: "",
      }));

      setAllMaterials(items);

      // Ambil daftar mesin untuk dropdown "Nama Mesin"
      const machineRes = await api.get("/machines");
      setMachines(Array.isArray(machineRes.data) ? machineRes.data : []);
    } catch (err) {
      console.log(err);
    }
  };

  // Opsi dropdown mesin (label dilengkapi kode & sektor agar mudah dibedakan)
  const machineOptions = machines.map((m) => ({
    value: m.name,
    label: `${m.name}${m.code ? ` — ${m.code}` : ""}${
      m.sector?.name ? ` (${m.sector.name})` : ""
    }`,
  }));

  /* =========================
     SAVE
  ========================= */

  const handleSave = async () => {
    if (saving) return; // cegah double submit saat jaringan lag
    try {
      setSaving(true);
      const selectedMaterials = allMaterials.filter((x) => Number(x.qty) > 0);

      // tidak ada material dipilih
      if (selectedMaterials.length === 0) {
        popup.alert("Silakan pilih material terlebih dahulu!");
        return;
      }

      // validasi form atas
      if (!form.mesin || !form.pic || !form.tanggal) {
        popup.alert("Lengkapi Nama Mesin, PIC dan Tanggal terlebih dahulu!");
        return;
      }

      // cek keterangan kosong
      const invalidMaterial = selectedMaterials.find(
        (x) => !x.note || x.note.trim() === "",
      );

      if (invalidMaterial) {
        popup.alert("Lengkapi keterangan untuk semua material yang diambil!");
        return;
      }

      const payload = {
        ...form,

        materials: selectedMaterials.map((x) => ({
          type: x.type,
          reference_id: x.id,
          qty: Number(x.qty),
          note: x.note,
        })),
      };

      console.log("PAYLOAD =", payload);

      const res = await api.post(
        "/maintenance/kaizen/save",
        payload,
      );
      popup.success(res.data.msg || "Data berhasil disimpan");

      setForm({
        mesin: "",
        pic: "",
        tanggal: "",
      });

      await loadData();
    } catch (err) {
      console.log(err);

      popup.error(err.response?.data?.msg || "Gagal menyimpan kaizen");
    } finally {
      setSaving(false);
    }
  };

  const filteredMaterials = allMaterials.filter((item) => {
    const keyword = search.toLowerCase();

    return (
      item.nama?.toLowerCase().includes(keyword) ||
      item.spesifikasi?.toLowerCase().includes(keyword)
    );
  });

  return (
    <div
      className="container-fluid p-0"
      style={{
        maxWidth: "100%",
        marginTop: "-23px",
      }}
    >
      <div
        className="card shadow border-0"
        style={{
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div className="card-body">
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h2 className="fw-bold mb-0" style={{ color: "#1e3a8a" }}>
              KAIZEN IMPROVEMENT
            </h2>
          </div>

          {/* =========================
              INFORMASI KAIZEN
          ========================= */}

          <div className="row mb-1">
            <div className="col-lg-4 col-md-6 col-12 mb-3">
              <label className="form-label fw-bold">Nama Mesin</label>

              <Select
                options={machineOptions}
                value={
                  machineOptions.find((opt) => opt.value === form.mesin) ||
                  (form.mesin ? { value: form.mesin, label: form.mesin } : null)
                }
                onChange={(selected) =>
                  setForm({ ...form, mesin: selected ? selected.value : "" })
                }
                placeholder="Pilih / cari mesin..."
                isClearable
                isSearchable
                noOptionsMessage={() => "Mesin tidak ditemukan"}
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : null
                }
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({ ...base, minHeight: "38px" }),
                }}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label fw-bold">PIC</label>

              <input
                type="text"
                className="form-control"
                placeholder="Input PIC"
                value={form.pic}
                onChange={(e) =>
                  setForm({
                    ...form,
                    pic: e.target.value,
                  })
                }
              />
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label fw-bold">Tanggal</label>

              <input
                type="date"
                className="form-control"
                value={form.tanggal}
                onChange={(e) =>
                  setForm({
                    ...form,
                    tanggal: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="card border mb-4">
            <div
              className="card-header text-white"
              style={{ background: "#1e3a8a" }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h5 className="mb-0">
                  <i className="fas fa-boxes me-2"></i>
                  Pengambilan Material Kaizen
                </h5>

                <div
                  className="d-flex align-items-center gap-2"
                  style={{ minWidth: "350px" }}
                >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="🔍 Cari material..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      maxWidth: "300px",
                      border: "none",
                    }}
                  />

                  <span className="badge bg-light text-primary">
                    Total Material : {filteredMaterials.length}
                  </span>
                </div>
              </div>
            </div>

            <div
              className="card-body"
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "55vh",
              }}
            >
              <table
                className="table table-bordered table-hover align-middle"
                style={{
                  borderCollapse: "collapse",
                  fontSize: "14px",
                  width: "100%",
                }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    minWidth: "900px",
                  }}
                >
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                        width: "60px",
                        textAlign: "center",
                      }}
                    >
                      No
                    </th>

                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                      }}
                    >
                      Jenis
                    </th>

                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                      }}
                    >
                      Material
                    </th>

                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                        textAlign: "center",
                      }}
                    >
                      Stock
                    </th>

                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                      }}
                    >
                      Qty Ambil
                    </th>

                    <th
                      style={{
                        backgroundColor: "#1e3a8a",
                        color: "#fff",
                        border: "1px solid #0b5ed7",
                      }}
                    >
                      Keterangan
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {allMaterials.length === 0 && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Belum ada material dipilih
                      </td>
                    </tr>
                  )}

                  {filteredMaterials.map((row, index) => (
                    <tr key={`${row.type}-${row.id}`}>
                      <td
                        className="text-center fw-bold"
                        style={{
                          verticalAlign: "middle",
                          width: "60px",
                        }}
                      >
                        {index + 1}
                      </td>

                      <td>
                        <span
                          className="badge bg-primary"
                          style={{ fontSize: "16px" }}
                        >
                          Sparepart
                        </span>
                      </td>

                      <td>
                        <div className="fw-bold text-dark">{row.nama}</div>

                        <div
                          style={{
                            fontSize: "12px",
                            color: "#6c757d",
                          }}
                        >
                          {row.spesifikasi}
                        </div>
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        <span
                          className={`badge ${
                            row.stock <= 3
                              ? "bg-danger"
                              : row.stock <= 10
                                ? "bg-warning text-dark"
                                : "bg-success"
                          }`}
                          style={{
                            fontSize: "14px",
                            minWidth: "35px",
                            display: "inline-block",
                          }}
                        >
                          {row.stock}
                        </span>
                      </td>

                      <td>
                        <input
                          type="number"
                          min="0"
                          max={row.stock}
                          className="form-control text-center"
                          value={row.qty}
                          onChange={(e) => {
                            const val = e.target.value;
                            setAllMaterials((prev) =>
                              prev.map((m) =>
                                m.id === row.id && m.type === row.type
                                  ? { ...m, qty: val }
                                  : m,
                              ),
                            );
                          }}
                        />
                      </td>

                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={row.note}
                          onChange={(e) => {
                            const val = e.target.value;
                            setAllMaterials((prev) =>
                              prev.map((m) =>
                                m.id === row.id && m.type === row.type
                                  ? { ...m, note: val }
                                  : m,
                              ),
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="d-flex justify-content-end p-0">
            <button
              className="btn btn-success px-4"
              onClick={handleSave}
              disabled={saving}
            >
              <i className="fas fa-save me-1"></i>
              {saving ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
